import React from 'react';

import { Div, SpacingProps } from '../../components/box';
import IconLabel, { IconLabelProps } from '../../components/icon-label/icon-label';

export interface FieldErrorProps {
  error: string | React.ReactNode;
  size?: IconLabelProps['size'];
  name: string;
  marginTop?: SpacingProps['marginTop'];
}

const FieldError = ({ error, size = 'md', name, marginTop = 'xxs' }: FieldErrorProps) => {
  return (
    <Div data-name={'error-message'} id={`${name}-error`} marginTop={marginTop}>
      <IconLabel size={size}>
        <IconLabel.Icon size={size} name={'EXCLAMATION_MARK'} variant={'negative'} aria-label={'Error'} />
        <IconLabel.Text size={size} weight={400} variant={'negative'}>
          {error}
        </IconLabel.Text>
      </IconLabel>
    </Div>
  );
};

export default FieldError;
